import { Helmet } from 'react-helmet'
import ClearFiltersButton from 'components/common/clearFiltersButton'
import {
  StockOutReportExportButton,
  StockOutReportFilterForm,
  StockOutReportTable,
} from 'components/stockOutReport'
import { FILTER_FIELD_STOCK_OUT_REPORT } from 'components/stockOutReport/utils'

const StockOutReportPage = () => {
  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Stock Out Report</title>
      </Helmet>

      <div className="flex items-center justify-between gap-2">
        <div className="title">Stock Out Report</div>

        <div className="flex flex-wrap items-center justify-end gap-1">
          <ClearFiltersButton filterKey={FILTER_FIELD_STOCK_OUT_REPORT} />

          <StockOutReportExportButton />
        </div>
      </div>

      <StockOutReportFilterForm />
      <StockOutReportTable />
    </>
  )
}

export default StockOutReportPage
